import { render, staticRenderFns } from "./StepCashRegister.vue?vue&type=template&id=618c792a&scoped=true&"
import script from "./StepCashRegister.vue?vue&type=script&lang=js&"
export * from "./StepCashRegister.vue?vue&type=script&lang=js&"
import style0 from "./StepCashRegister.vue?vue&type=style&index=0&id=618c792a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618c792a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VForm,VRow,VSelect,VTextField})
